/**
 * sophior-carousel.js
 * Gedeelde auto-scroll carousel. Vervangt drie vrijwel identieke inline
 * scripts (trustbadge-bar, pre-footer trustbar, PDP trust-USPs).
 *
 * Gebruik op het scrollende element:
 *   data-sophior-carousel=".item-selector"   (verplicht, selector van de items)
 *   data-carousel-mobile-only                (alleen actief onder 750px)
 *   data-carousel-skip-if-fits               (niet starten als alles al past)
 *
 * Gedrag: pauzeert bij touch (hervat na 4s), respecteert
 * prefers-reduced-motion, en draait alleen wanneer het element in beeld
 * is (IntersectionObserver) zodat offscreen carousels de main thread
 * niet wakker houden.
 */
(function () {
  function init(el) {
    if (el.dataset.sophiorCarouselInit === '1') return;
    el.dataset.sophiorCarouselInit = '1';

    var items = el.querySelectorAll(el.getAttribute('data-sophior-carousel'));
    if (items.length <= 1) return;
    if (el.hasAttribute('data-carousel-mobile-only') && !window.matchMedia('(max-width: 749px)').matches) return;
    if (el.hasAttribute('data-carousel-skip-if-fits') && el.scrollWidth <= el.clientWidth) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var current = 0;
    var paused = false;
    var visible = true;

    el.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    el.addEventListener('touchend', function () {
      setTimeout(function () { paused = false; }, 4000);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }).observe(el);
    }

    setInterval(function () {
      if (paused || !visible) return;
      current = (current + 1) % items.length;
      el.scrollTo({ left: current * el.clientWidth, behavior: 'smooth' });
    }, 3000);
  }

  function initAll() {
    document.querySelectorAll('[data-sophior-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
